module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVAgMAAAA7uyY7AAAADFBMVEUAAAAUp/ATqfEUqPAG0MPmAAAAA3RSTlMAplkQnDbhAAAAJ0lEQVQI12NgYNBgAAEbkshVq/atWsXwHwQYQkNrQ0Mh4iSRIgwMAIwrDi9LxwJoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/add.png
// module id = LklT
// module chunks = 2